import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import AuthContext from "../contexts/AuthProvider";
import { BASE_URL } from "../constants";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";
import Image from "../assets/loginbg1.png";
import { Button, Grid, TextField, Typography } from "@mui/material";
import NotificationAlert from "./NotificationAlert";

const LoginMui = () => {
  const { setAuth, setLoggedInUserEmail } = useContext(AuthContext);
  const { state } = useLocation();
  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  // const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputStyle = {
    WebkitTextFillColor: "#fff",
    transition: "background-color 5000s ease-in-out 0s",
  };

  const handleChange = (event) => {
    console.log(event.target.value);
    setUser({
      ...user,
      [event.target.name]: event.target.value,
    });
  };

  async function handleSubmit(event) {
    event.preventDefault();
    // setLoading(true);
    let result, msg;

    try {
      const data = {
        email: user.email,
        password: user.password,
      };
      result = await axios
        .post(`${BASE_URL}auth/login`, JSON.stringify(data), {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        })
        .then((response) => {
          return response.status;
        });
    } catch (e) {
      result = e.response.status;
      msg = e.response.data.message;
      // setLoading(false);
    }

    if (result === 200) {
      setAuth(true);
      navigate(state?.path || "/dashboard");
      setLoggedInUserEmail(user.email);
    } else {
      setError(msg);
      setNotify({
        isOpen: true,
        message: msg,
        type: "warning",
      });
      console.log(error);
    }
  }

  useEffect(() => {
    axios
      .get(`${BASE_URL}auth/clearcookie`, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
      .then((response) => {
        navigate("/");
        //setAuth(false);
        setLoggedInUserEmail("");
        console.log(response);
        // return response.status;
      })
      .catch((e) => {
        dispatch(setError(["Error in Clearing Cookie!", e, false]));
      });
  }, []);

  return (
    <Box
      sx={{
        background: `url(${Image})`,
        height: "100vh",
        backgroundSize: "cover",
      }}
    >
      <Box>
        <img
          style = {{ width: "200px", padding: "20px" }}
          src="https://infomate-trial.s3.amazonaws.com/public_assets/Infomate360+Logo.png"
          alt="Infomate360-Logo"
        />
      </Box>
      <NotificationAlert notify={notify} setNotify={setNotify} />
      <Box
        sx={{
          width: "360px",
          height: "450px",
          background: "rgba(0, 0, 0, 0.90)",
          color: "#fff",
          top: "15%",
          left: "60%",
          position: "absolute",
          boxSizing: "border-box",
          borderRadius: "0px 70px",
          padding: "50px 60px",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} lg={12}>
              <Typography variant="h4" align="center">
                Log In
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} lg={12} my={1}>
              <Typography variant="body1" mb={2}>
                Username
              </Typography>
              <TextField
                inputProps={{ style: inputStyle }}
                sx={{
                  width: "100%",
                  input: { color: "#fff", border: "1px solid #fff" },
                  "& .MuiOutlinedInput-root": {
                    "& > fieldset": {
                      border: "none",
                    },
                  },
                }}
                name="email"
                size="small"
                placeholder="Enter username here"
                type="email"
                value={user.email}
                required
                onChange={(e) => handleChange(e)}
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <Typography variant="body1" mb={2}>
                Password
              </Typography>
              <TextField
                inputProps={{ style: inputStyle }}
                sx={{
                  underline: {
                    "&&&:before": {
                      borderBottom: "none",
                    },
                    "&&:after": {
                      borderBottom: "none",
                    },
                  },
                  width: "100%",
                  input: { color: "#fff", border: "1px solid #fff" },
                  "& .MuiOutlinedInput-root": {
                    "& > fieldset": {
                      border: "none",
                    },
                  },
                }}
                variant="outlined"
                name="password"
                size="small"
                placeholder="Enter password here"
                type="password"
                value={user.password}
                required
                onChange={(e) => handleChange(e)}
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12} mt={2}>
              <Button
                size="medium"
                variant="contained"
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  textTransform: "none",
                }}
                type="submit"
              >
                Login
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};

export default LoginMui;
